<script setup lang="ts">
    import type { FilterOption } from '~/types/filters';

    const props = defineProps<{
        selectedFilters: Record<string, FilterOption>;
        filteredEntries: number;
        totalEntries?: number | null;
        productCountTranslation?: string;
    }>();

    const emit = defineEmits(['remove']);

    const { t } = useI18n();

    const productCountTranslationWithFallback = props.productCountTranslation || 'pagePlp.productCount';
</script>

<template>
    <div class="filter-chips">
        <ul class="selected-filter-list">
            <template
                v-for="[type, filter] in Object.entries(selectedFilters)"
                :key="type"
            >
                <Transition name="tab">
                    <li v-if="filter">
                        <button
                            type="button"
                            @click="emit('remove', type)"
                        >
                            <span v-if="typeof filter.key === 'boolean'">{{ filter.label }}</span>
                            <span v-else>
                                {{ t(`pagePlp.filterValues.bucketKeys.${filter.key}`, filter.key) }}
                            </span>
                            <span>&#x2715;</span>
                        </button>
                    </li>
                </Transition>
            </template>
        </ul>

        <p class="product-count-text">
            {{ t(productCountTranslationWithFallback, { n: filteredEntries, total: totalEntries || 0 }) }}
        </p>
    </div>
</template>

<style scoped>
    @import '~/assets/scss/filter/filter-chips.scss';
    @import '~/assets/scss/filter/filter-shared.scss';
</style>
